import PropTypes from 'prop-types';

import { Content, Title, WarningText } from './confirm.styled';
import { Dialog } from '../dialog/dialog';

export const Confirm = (props) => {
  const { width = '440px', type, title, info, cancelButton, acceptButton, working, ...rest } = props;

  /**
   * cancel confirm
   */
  const close = () => {
    if (cancelButton) {
      cancelButton.func();
    }
  };

  /**
   * disable click
   * @param {*} event
   */
  const disableClick = (event) => {
    event.stopPropagation();
  };

  const buttons = [];
  if (cancelButton) {
    buttons.push({ title: cancelButton.text, onClick: cancelButton.func });
  }
  if (acceptButton) {
    buttons.push({
      title: acceptButton.text,
      onClick: acceptButton.func,
      theme: acceptButton.theme,
      backgroundColor: acceptButton.backgroundColor,
      disabled: working,
      working,
      img: acceptButton.img,
    });
  }
  const cl = type;

  return (
    <Dialog {...rest} closeOnOverlayClick close={close} id="confirm" buttons={buttons}>
      {/* {type && type === 'error' ? <img width={50} height={50} src="/images/error-icon.png" alt="" /> : <img width={50} height={47} src="/images/warning.png" alt="" />} */}
      <Content className={cl}>
        <Title>{title}</Title>
        {typeof info === 'object' && info.__html ? <WarningText dangerouslySetInnerHTML={info} /> : info && <WarningText>{info}</WarningText>}
      </Content>
    </Dialog>
  );
};

Confirm.propTypes = {
  working: PropTypes.bool,
  width: PropTypes.any,
  type: PropTypes.string,
  title: PropTypes.any.isRequired,
  info: PropTypes.string,
  cancelButton: PropTypes.object,
  acceptButton: PropTypes.object,
};
